<span *ngIf="origin && !sapClientData" [matTooltip]="tooltip ? tooltip : (origin | monitoringFilterAdjustUiPipe)">
  {{ origin[0] }}
</span>

<span *ngIf="origin && sapClientData" [matTooltip]="sapDetails">
  {{ origin[0] }}
</span>
